import { DutyPayer, VatTreatment } from 'store/customers/customer';

export const FormFields = {
    CustomerDetails: {
        CUSTOMER_NAME: 'customerName',
        REFERENCE_CODE: 'referenceCode',
        EORI: 'eori',
        TRADER_ACCOUNT_NUMBER: 'tan',
        DEFERRED_ACCOUNT_NUMBER: 'deferredAccountNumber',
        VAT_NUMBER: 'vatNumber',
        ADDRESS_LINE_1: 'addressLine1',
        ADDRESS_LINE_2: 'addressLine2',
        COUNTRY: 'country',
        POST_CODE: 'postCode',
        CITY: 'city',
    },
    ContactDetails: {
        CONTACT_NAME: 'contactName',
        EMAIL: 'email',
        PHONE_NUMBER: 'phoneNumber',
        PHONE_CODE: 'phoneCountryCode',
    },
    DutyAndVat: {
        DUTY_PAYER: 'dutyPayer',
        HAS_AEP5_AUTHORIZATION: 'hasAEP5Authorization',
        VAT_TREATMENT: 'vatTreatment',
        VAT_EXEMPTION: 'vatExemption',
    },
    Billing: {
        RECIPIENT_NAME: 'recipientName',
        BILLING_EMAIL: 'billingEmail',
        THIRD_PARTY_BILLING: 'thirdPartyBilling',
        BILLING_CUSTOMER_CODE: 'billingCustomerCode',
    },
    SpecialInstructions: {
        SPECIAL_INSTRUCTIONS: 'specialInstructions',
    },
} as const;

/**
 * Fields the overview form marks as required. Kept in sync with the required entries of
 * getOverviewValidationSchema — that schema can't be reused for a presence check because the
 * EORI rule runs an async request against the EORI service.
 */
export const REQUIRED_OVERVIEW_FIELDS = [
    FormFields.CustomerDetails.CUSTOMER_NAME,
    FormFields.CustomerDetails.REFERENCE_CODE,
    FormFields.CustomerDetails.EORI,
    FormFields.CustomerDetails.ADDRESS_LINE_1,
    FormFields.CustomerDetails.COUNTRY,
    FormFields.CustomerDetails.POST_CODE,
    FormFields.CustomerDetails.CITY,
    FormFields.ContactDetails.CONTACT_NAME,
    FormFields.ContactDetails.EMAIL,
    FormFields.DutyAndVat.DUTY_PAYER,
    FormFields.DutyAndVat.VAT_TREATMENT,
] as const;

export interface FormValues {
    [FormFields.CustomerDetails.CUSTOMER_NAME]: string | null;
    [FormFields.CustomerDetails.REFERENCE_CODE]: string | null;
    [FormFields.CustomerDetails.EORI]: string | null;
    [FormFields.CustomerDetails.TRADER_ACCOUNT_NUMBER]: string | null;
    [FormFields.CustomerDetails.DEFERRED_ACCOUNT_NUMBER]: string | null;
    [FormFields.CustomerDetails.VAT_NUMBER]: string | null;
    [FormFields.CustomerDetails.ADDRESS_LINE_1]: string | null;
    [FormFields.CustomerDetails.ADDRESS_LINE_2]: string | null | undefined;
    [FormFields.CustomerDetails.COUNTRY]: string | null;
    [FormFields.CustomerDetails.POST_CODE]: string | null;
    [FormFields.CustomerDetails.CITY]: string | null;
    [FormFields.ContactDetails.CONTACT_NAME]: string | null;
    [FormFields.ContactDetails.EMAIL]: string | null;
    [FormFields.ContactDetails.PHONE_NUMBER]: string | null;
    [FormFields.ContactDetails.PHONE_CODE]: string | null;
    [FormFields.DutyAndVat.DUTY_PAYER]: DutyPayer | null;
    [FormFields.DutyAndVat.VAT_TREATMENT]: VatTreatment | null;
    [FormFields.DutyAndVat.VAT_EXEMPTION]: boolean | null;
    [FormFields.DutyAndVat.HAS_AEP5_AUTHORIZATION]: boolean | null;
    [FormFields.Billing.RECIPIENT_NAME]: string | null;
    [FormFields.Billing.BILLING_EMAIL]: string | null;
    [FormFields.Billing.THIRD_PARTY_BILLING]: string | null;
    [FormFields.Billing.BILLING_CUSTOMER_CODE]: string | null;
    [FormFields.SpecialInstructions.SPECIAL_INSTRUCTIONS]: string | null;
}
